<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title" *ngIf="!locationGroup || !locationGroup?.id">
      {{ 'LOCATIONS_GROUPS.DIALOG.TITLE_NEW' | translate }}
    </h2>
    <h2 class="field-dialog__header__title" *ngIf="locationGroup && locationGroup.id">
      {{ locationGroup.name }}
    </h2>

    <button class="field-dialog__header__close" mat-icon-button (click)="matDialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <mat-tab-group class="field-dialog__content">
    <mat-tab label="Geral">
      <disclaimer *ngIf="isViewMode" [message]="'LOCATIONS_GROUPS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
      <tab-locations-groups (getLocationGroupForm)="getForm($event)"></tab-locations-groups>
    </mat-tab>
  </mat-tab-group>

  <div *ngIf="!isViewMode" class="field-dialog__footer" fxLayout="row" fxLayoutAlign="space-between center">
    <button class="field-background" mat-raised-button (click)="onSaveClick()" [disabled]="isInvalidForm || isSaving">
      {{ 'LOCATIONS_GROUPS.DIALOG.BUTTON.SAVE' | translate }}
    </button>

    <div *ngIf="locationGroup?.id">
      <button
        *ngIf="!locationGroup.archived"
        mat-icon-button
        (click)="onArchivedClick(true)"
        [disabled]="isInvalidForm || isSaving"
        matTooltip="{{ 'LOCATIONS_GROUPS.DIALOG.BUTTON.ARCHIVE' | translate }}"
      >
        <mat-icon>archive</mat-icon>
      </button>

      <button
        *ngIf="locationGroup.archived"
        mat-icon-button
        (click)="onArchivedClick(false)"
        [disabled]="isInvalidForm || isSaving"
        matTooltip="{{ 'LOCATIONS_GROUPS.DIALOG.BUTTON.UNARCHIVE' | translate }}"
      >
        <mat-icon>unarchive</mat-icon>
      </button>
    </div>
  </div>
</div>
